/**
 * Pure classification + copy for the mic-enable prompt. Maps a LiveKit
 * media-device failure to a UI-facing error kind, filtering out failures
 * that are not about the microphone. No React, no store, no side effects.
 */
/**
 * Maps a LiveKit `MediaDeviceFailure` (as delivered by
 * `<LiveKitRoom onMediaDeviceFailure>`) to a `MicErrorKind`, or `null` when
 * the failure is not about an audio input device and should be ignored.
 * `kind` is `undefined` for failures LiveKit could not attribute to a device
 * kind; we treat that as a possible mic failure.
 */
export function micErrorFromFailure(failure, kind) {
    if (kind != null && kind !== "audioinput")
        return null;
    const f = failure;
    switch (f) {
        case "PermissionDenied":
            return "denied";
        case "NotFound":
            return "no_device";
        case "DeviceInUse":
            return "device_busy";
        default:
            return "other";
    }
}
/** Hard-coded prompt copy. House style: no em-dashes or en-dashes. */
export const MIC_ERROR_COPY = {
    denied: {
        title: "Microphone blocked",
        body: "Allow mic access in your browser, then tap Try again. Look for the mic icon in the address bar.",
    },
    no_device: {
        title: "No microphone found",
        body: "Connect a microphone, then tap Try again.",
    },
    device_busy: {
        title: "Microphone in use",
        body: "Another app is using your mic. Close it, then tap Try again.",
    },
    other: {
        title: "Can't access your mic",
        body: "Check your microphone settings, then tap Try again.",
    },
};
